const IOS_DEVICE_REGEX = /iPad|iPhone|iPod/;
const ANDROID_DEVICE_REGEX = /android\s([0-9.]*)/i;

const getAndroidVersion = () => {
  const matches = navigator.userAgent.match(ANDROID_DEVICE_REGEX);
  if(!matches) return;
  return matches[1];
}

const getMajorVersion = (version) => {
  const majorVersion = parseInt(version);
  if(isNaN(majorVersion)) {
    console.warn(`getMajorVersion(version)的参数必须是有效的sematic version格式`)
    return -1;
  };
  return majorVersion;
}

export const ANDROID_Q_VERSION = 10;

export const isIOS = IOS_DEVICE_REGEX.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

export const isAndroid = ANDROID_DEVICE_REGEX.test(navigator.userAgent);

export const androidFullVersion = getAndroidVersion();

export const androidMajorVersion = getMajorVersion(androidFullVersion || "");